import { ref, watch, computed } from '@vue/composition-api'

import useJwt from "@/auth/jwt/useJwt";
import CISSettingService from '@/services/cis-setting.service'

import store from "@/store";

export default function cisPricesList() {
  const refPricesTable = ref(null)

  // Table Handlers
  const tableColumns = [
    { key: 'title', label: 'title', sortable: false },
    { key: 'desc', label: 'description', sortable: false },
    { key: 'price', label: 'price', sortable: false },
    { key: 'period', label: 'period', sortable: false },
    { key: 'maxAnalPeriod', label: 'anal period', sortable: false },
    { key: 'maxCateNum', label: 'max categories', sortable: false },
    { key: 'maxMemNum', label: 'max members', sortable: false },
    { key: 'openMenu', label: 'open menu', sortable: false },
    { key: 'actions', sortable: false },
  ]
  const perPage = ref(10)
  const totalPrices = ref(0)
  const currentPage = ref(1)
  const perPageOptions = [10, 25, 50, 100]
  const searchQuery = ref('')
  const sortBy = ref('id')
  const isSortDirDesc = ref(true)
  const statusFilter = ref(null)

  const dataMeta = computed(() => {
    const localItemsCount = refPricesTable.value ? refPricesTable.value.localItems.length : 0
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalPrices.value,
    }
  })

  const reFetchData = () => {
    refPricesTable.value.refresh()
  }

  watch([currentPage, perPage, searchQuery, statusFilter], () => {
    reFetchData()
  })

  const fetchPrices = (ctx, callback) => {
    
    CISSettingService.priceListSetting({
      search: searchQuery.value,
      pageNumber: currentPage.value - 1,
      pageSize: perPage.value,
      sortBy: sortBy.value,
      sortDesc: isSortDirDesc.value,
      status: statusFilter.value
    }).then(response => {
      if (response && response.data.success) {
        console.log('-- priceList --')
        console.log(response.data.data)
        const { data, total } = response.data
        callback(data)
        totalPrices.value = total
      }
    })
  }

  return {
    fetchPrices,
    tableColumns,
    perPage,
    currentPage,
    totalPrices,
    dataMeta,
    perPageOptions,
    searchQuery,
    sortBy,
    isSortDirDesc,
    refPricesTable,

    statusFilter,

    reFetchData
  }
}
